module.exports = __webpack_public_path__ + "pontopravida.jpg?584af32e63f2c67a2622864bb9a344df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/pontopravida.jpg
// module id = 147
// module chunks = 0